import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useToast } from "@chakra-ui/react";
import { queryKeys } from "../queryKeys";
import { AxiosError } from "axios";
import { EntityCandidate } from "../models/EntityCandidate";
import { axiosInstance } from "../../utils";
import { JsonPatchOp } from "../../utils/buildJsonPatch";

export interface CandidatePatchArgs {
    clientId: string | undefined;
    entityId: string | undefined;
    candidateId: string | undefined;
    patch: JsonPatchOp[];
}

export function useCandidatePatch() {
    const axios = axiosInstance(),
        queryClient = useQueryClient();
    const toast = useToast();

    return useMutation({
        mutationFn: (args: CandidatePatchArgs) =>
            axios
                .patch<EntityCandidate>(`api/clients/${args.clientId}/entities/${args.entityId}/candidates/${args.candidateId}`, args.patch, {
                    headers: { "Content-Type": "application/json-patch+json" },
                })
                .then(r => r.data),
        onSuccess: async data => {
            await queryClient.invalidateQueries(queryKeys.candidates.byEntity._def);
            queryClient.setQueryData(queryKeys.candidates.byCandidateId(data.id).queryKey, data);
        },
        onError: error => {
            const axiosError = error as AxiosError;
            toast({
                title: "Unable to save candidate",
                description: `[${axiosError.request?.status ?? "ERR"}]: ${axiosError.message}`,
                status: "error",
                isClosable: true,
                duration: null,
            });
        },
    });
}
